import { put } from '../base';

export async function setProductEditorTerms(accepted: boolean): Promise<void> {
  await put(`v5/user/productEditorTerms`, { json: { accepted } });
}
